/*!

=========================================================
* Central System - v1.0.0
=========================================================

* Coded by Aircode

=========================================================

*/
import React, { useEffect, useState } from 'react';

// reactstrap components
import { Card, CardBody, CardTitle, Row, Col, Spinner } from "reactstrap";
// core components
import { getGroups, reportStudentCollections } from "../../../../network/ApiAxios.js";
import secureLocalStorage from "react-secure-storage";

const KPIGroups = (props) => {
  const [isLoading, setisLoading] = useState(false)
  const [groups, setGroups] = useState([])
  const [collections, setCollections] = useState([])
  const user = JSON.parse(secureLocalStorage.getItem("user"));
  const app = JSON.parse(secureLocalStorage.getItem("app"));

  useEffect(() => {
    const runCountStudents = async () => {
      setisLoading(true);

      let params = {
        filter: { account: user.account, active: true },
      }

      const response = await getGroups(params);
      const { data } = response;

      if (data.success) {
        setGroups(data.groups.length)
        let groupWithCollection = 0
        let totalCollections = 0

        for (let i = 0; i < data.groups.length; i++) {
          let group = data.groups[i]
          let params = {
            filter: { studendIds: group.students },
            constraint: { app: app._id }
          }
          const response = await reportStudentCollections(params);

          if (response.data.success) {
            groupWithCollection += response.data.report.withCollections
            totalCollections += response.data.report.totalCollections
          }

          setCollections({
            withCollections: groupWithCollection,
            totalCollections: totalCollections
          })
        }        
      }
      
      setisLoading(false);
    }

    runCountStudents();

  }, []);

  return (
    <>
      <Card className="card-stats mb-4 mb-xl-0">
        {
          isLoading ?
            <div className="text-center p-5">
              <Spinner size="lg" />
            </div>
            :
            <CardBody>
              <Row>
                <div className="col">
                  <CardTitle
                    tag="h5"
                    className="text-uppercase text-muted mb-0"
                  >
                    Groups
                  </CardTitle>
                  <span className="h2 font-weight-bold mb-0">{groups}</span>
                </div>
                <Col className="col-auto">
                  <div className="icon icon-shape bg-blue text-white rounded-circle shadow">
                    <i className="fas fa-layer-group" />
                  </div>
                </Col>
              </Row>
              <p className="mt-3 mb-0 text-muted text-sm">
                <span className="text-success mr-2">
                  {collections.withCollections}
                </span>{" "}
                <span className="text-nowrap">With Collections</span>
              </p>
              <p className="mt-3 mb-0 text-muted text-sm">
                <span className="text-success mr-2">
                  {collections.totalCollections}
                </span>{" "}
                <span className="text-nowrap">Total Collections</span>
              </p>
            </CardBody>
        }
      </Card>
    </>
  );
};

export default KPIGroups;
